import React, { useEffect, useState } from 'react';
import '../../../../../App.css';
import { Modal, Table } from 'antd';
import {

  useGetFailedTransactions
} from '../hooks/usePayment';
import { Layout } from '../../layout';
import { useNavigate } from 'react-router-dom';
import { searchCollection } from '../../../../../core/assets/icons';
import moment from 'moment';
import { notePencil } from '../../../../../core/assets/imgs';

function dragAndDrop() {
  const dragDropArea = document.getElementById('uploadArea');
}

const FailedPayments = () => {
  const [selectedRowKeys, setSelectedRowKeys] = useState<React.Key[]>([]);
  const [dataSource, setDataSource] = useState<any[]>([]);
  const [totalPayableSum, setTotalPayableSum] = useState<any>(0);

  const [confirmationModal, setConfirmationModal] = useState(false);
  const [successModal, setSuccessModal] = useState(false);
  const [accountToMakePaymentFrom, setAccountToMakePaymentFrom] = useState('');

  const { data, mutate, isLoading } = useGetFailedTransactions();


  const navigate = useNavigate();

  let totalAmount = 0;
  const onSelectChange = (newSelectedRowKeys: React.Key[]) => {
    //console.log("selectedRowKeys changed: ", newSelectedRowKeys);
    setSelectedRowKeys(newSelectedRowKeys);
  };

  const rowSelection = {
    selectedRowKeys,
    onChange: onSelectChange,
  };

  const handleSubmit = (_) => {
        
            navigate("/admin/payment/rejected-payments-details",  { state: { data: _ } } );
        }
    

useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
    mutate();
  }, []);

  const columns = [
    {
      title: ' ID',
      dataIndex: 'id',
      key: 'id',
    },
    {
      title: 'Batch Number/VoxePay Payment Reference ',
      dataIndex: 'batchNumber',
      key: 'batchNumber',
    },
    {
      title: 'Payment Type',
      dataIndex: 'paymentType',
      key: 'paymentType',
    },
    {
      title: 'Payment Option',
      dataIndex: 'paymentOption',
      key: 'paymentOption',
    },
    {
      title: 'Failed Date & Time Stamp',
      dataIndex: 'rejectionDate',
      key: 'rejectionDate',
    },

    {
      title: 'Failed Stage',
      dataIndex: 'rejectionStage',
      key: 'rejectionStage',
    },
    {
      title: 'Reviewer',
      dataIndex: 'reviewer',
      key: 'reviewer',
    },
     {
      title: 'Approver',
      dataIndex: 'approver',
      key: 'approver',
    },
         {
      title: "Action",
      dataIndex: "action",
      render: (_, record: any) => (
        <div
          className={`${record.editable ? "cursor-pointer" : ""}`}
          onClick={() => handleSubmit(_)}
        >
          <img src={notePencil} alt="Description" className="w-1r1 h-1r1" />
          <span
            className={`ms-2 fw-bold ${
              record.editable ? "text-dark" : "text-muted"
            }`}
          >
            View Details
          </span>
        </div>
      ),
    },
  ];


    const dataSourceD: any[] = [];


  for (let i = 0; i < data?.length; i++) {

    console.log();

    let paymentType = data[i]?.content?.data?.paymentInstructions.length > 1 ? 'Bulk' : 'Single'
    

    

          const datad = {
        key: i.toString(),
        id: i +1,
            batchNumber: data[i]?.content?.data?.batchId,
            paymentType: data[i]?.content.data.paymentInstructions['0'].paymentType.description,
            paymentOption: paymentType,
            rejectionDate: moment(data[i]?.lastReviewedDate).format("MMMM Do YYYY, h:mm a"),
            rejectionReason: data[i]?.content?.data?.reason,
            rejectionStage: data[i]?.requestReview?.businessGroupCode,
            reviewer: data[i]?.reviewer,
            approver: '',
            action: data[i]
        
         
      
      };
      dataSourceD.push(datad);

  }



  return (
    <>
      <div className={'rejectedPayments'}>
        <div className={'rejectedPaymentsBreadcrumb'}>
          <div>Payments</div>
          <svg
            width="10"
            height="13"
            viewBox="0 0 10 13"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M0 1.5744L0 11.4256C0 11.8254 0.236844 12.192 0.613658 12.3774C0.991157 12.5628 1.44706 12.5363 1.79669 12.3087L9.55942 7.25661C9.83645 7.07665 10.0007 6.78017 10 6.46438C9.99858 6.14825 9.83207 5.85271 9.55431 5.6742L1.79158 0.68791C1.44044 0.462617 0.986688 0.438175 0.610557 0.623958C0.235339 0.809997 0 1.1757 0 1.5744Z"
              fill="#6366F1"
            />
          </svg>
          <div>Reprocess Unpaid Payments</div>

          <svg
            width="10"
            height="13"
            viewBox="0 0 10 13"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M0 1.5744L0 11.4256C0 11.8254 0.236844 12.192 0.613658 12.3774C0.991157 12.5628 1.44706 12.5363 1.79669 12.3087L9.55942 7.25661C9.83645 7.07665 10.0007 6.78017 10 6.46438C9.99858 6.14825 9.83207 5.85271 9.55431 5.6742L1.79158 0.68791C1.44044 0.462617 0.986688 0.438175 0.610557 0.623958C0.235339 0.809997 0 1.1757 0 1.5744Z"
              fill="#6366F1"
            />
          </svg>

          <div>Failed Payments</div>
        </div>

        <div className={'rejectedPaymentsSummary'}>
          <div className={'rpsRow1'}>
            <div>FAILED TRANSACTIONS</div>

            <div>
              <div></div>
              <div>
             <span className='psTitle'>Download report</span>   
                <span className='m-2'>
                  <svg
                    width="30"
                    height="30"
                    viewBox="0 0 30 30"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <rect
                      x="0.5"
                      y="0.5"
                      width="29"
                      height="29"
                      rx="1.5"
                      fill="white"
                    />
                    <path
                      d="M17.8128 3.75H6.56245C6.31382 3.75001 6.07537 3.84878 5.89956 4.0246C5.72376 4.20041 5.62499 4.43887 5.625 4.6875V25.3125C5.62499 25.5611 5.72376 25.7996 5.89956 25.9754C6.07537 26.1512 6.31382 26.25 6.56245 26.25H23.4375C23.6862 26.25 23.9246 26.1512 24.1004 25.9754C24.2762 25.7996 24.375 25.5611 24.375 25.3125V10.3125M17.8128 3.75L24.375 10.3125M17.8128 3.75L17.8125 10.3125H24.375"
                      stroke="#FBD0D1"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <rect
                      x="0.5"
                      y="0.5"
                      width="29"
                      height="29"
                      rx="1.5"
                      stroke="#E8E8E8"
                    />
                    <path
                      d="M10.252 16.156C10.36 16.004 10.508 15.878 10.696 15.778C10.888 15.674 11.106 15.622 11.35 15.622C11.634 15.622 11.89 15.692 12.118 15.832C12.35 15.972 12.532 16.172 12.664 16.432C12.8 16.688 12.868 16.986 12.868 17.326C12.868 17.666 12.8 17.968 12.664 18.232C12.532 18.492 12.35 18.694 12.118 18.838C11.89 18.982 11.634 19.054 11.35 19.054C11.106 19.054 10.89 19.004 10.702 18.904C10.518 18.804 10.368 18.678 10.252 18.526V20.584H9.41205V15.676H10.252V16.156ZM12.01 17.326C12.01 17.126 11.968 16.954 11.884 16.81C11.804 16.662 11.696 16.55 11.56 16.474C11.428 16.398 11.284 16.36 11.128 16.36C10.976 16.36 10.832 16.4 10.696 16.48C10.564 16.556 10.456 16.668 10.372 16.816C10.292 16.964 10.252 17.138 10.252 17.338C10.252 17.538 10.292 17.712 10.372 17.86C10.456 18.008 10.564 18.122 10.696 18.202C10.832 18.278 10.976 18.316 11.128 18.316C11.284 18.316 11.428 18.276 11.56 18.196C11.696 18.116 11.804 18.002 11.884 17.854C11.968 17.706 12.01 17.53 12.01 17.326ZM13.2625 17.326C13.2625 16.99 13.3285 16.692 13.4605 16.432C13.5965 16.172 13.7805 15.972 14.0125 15.832C14.2445 15.692 14.5025 15.622 14.7865 15.622C15.0025 15.622 15.2085 15.67 15.4045 15.766C15.6005 15.858 15.7565 15.982 15.8725 16.138V14.56H16.7245V19H15.8725V18.508C15.7685 18.672 15.6225 18.804 15.4345 18.904C15.2465 19.004 15.0285 19.054 14.7805 19.054C14.5005 19.054 14.2445 18.982 14.0125 18.838C13.7805 18.694 13.5965 18.492 13.4605 18.232C13.3285 17.968 13.2625 17.666 13.2625 17.326ZM15.8785 17.338C15.8785 17.134 15.8385 16.96 15.7585 16.816C15.6785 16.668 15.5705 16.556 15.4345 16.48C15.2985 16.4 15.1525 16.36 14.9965 16.36C14.8405 16.36 14.6965 16.398 14.5645 16.474C14.4325 16.55 14.3245 16.662 14.2405 16.81C14.1605 16.954 14.1205 17.126 14.1205 17.326C14.1205 17.526 14.1605 17.702 14.2405 17.854C14.3245 18.002 14.4325 18.116 14.5645 18.196C14.7005 18.276 14.8445 18.316 14.9965 18.316C15.1525 18.316 15.2985 18.278 15.4345 18.202C15.5705 18.122 15.6785 18.01 15.7585 17.866C15.8385 17.718 15.8785 17.542 15.8785 17.338ZM19.0689 16.366H18.4869V19H17.6349V16.366H17.2569V15.676H17.6349V15.508C17.6349 15.1 17.7509 14.8 17.9829 14.608C18.2149 14.416 18.5649 14.326 19.0329 14.338V15.046C18.8289 15.042 18.6869 15.076 18.6069 15.148C18.5269 15.22 18.4869 15.35 18.4869 15.538V15.676H19.0689V16.366Z"
                      fill="#EE151D"
                    />
                  </svg>
                </span>
                <span className='m-2'>
                  <svg
                    width="30"
                    height="30"
                    viewBox="0 0 30 30"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <rect
                      x="0.5"
                      y="0.5"
                      width="29"
                      height="29"
                      rx="1.5"
                      fill="white"
                    />
                    <path
                      d="M17.8128 3.75H6.56245C6.31382 3.75001 6.07537 3.84878 5.89956 4.0246C5.72376 4.20041 5.62499 4.43887 5.625 4.6875V25.3125C5.62499 25.5611 5.72376 25.7996 5.89956 25.9754C6.07537 26.1512 6.31382 26.25 6.56245 26.25H23.4375C23.6862 26.25 23.9246 26.1512 24.1004 25.9754C24.2762 25.7996 24.375 25.5611 24.375 25.3125V10.3125M17.8128 3.75L24.375 10.3125M17.8128 3.75L17.8125 10.3125H24.375"
                      stroke="#A5CE9B"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <rect
                      x="0.5"
                      y="0.5"
                      width="29"
                      height="29"
                      rx="1.5"
                      stroke="#E8E8E8"
                    />
                    <path
                      d="M13.9082 19L13.2242 17.968L12.6182 19H11.7182L12.8042 17.332L11.7062 15.676H12.6542L13.3322 16.702L13.9442 15.676H14.8442L13.7522 17.332L14.8562 19H13.9082ZM16.1524 14.56V19H15.3124V14.56H16.1524ZM18.2544 19.054C17.9824 19.054 17.7384 19.006 17.5224 18.91C17.3064 18.81 17.1344 18.676 17.0064 18.508C16.8824 18.34 16.8144 18.154 16.8024 17.95H17.6484C17.6644 18.078 17.7264 18.184 17.8344 18.268C17.9464 18.352 18.0844 18.394 18.2484 18.394C18.4084 18.394 18.5324 18.362 18.6204 18.298C18.7124 18.234 18.7584 18.152 18.7584 18.052C18.7584 17.944 18.7024 17.864 18.5904 17.812C18.4824 17.756 18.3084 17.696 18.0684 17.632C17.8204 17.572 17.6164 17.51 17.4564 17.446C17.3004 17.382 17.1644 17.284 17.0484 17.152C16.9364 17.02 16.8804 16.842 16.8804 16.618C16.8804 16.434 16.9324 16.266 17.0364 16.114C17.1444 15.962 17.2964 15.842 17.4924 15.754C17.6924 15.666 17.9264 15.622 18.1944 15.622C18.5904 15.622 18.9064 15.722 19.1424 15.922C19.3784 16.118 19.5084 16.384 19.5324 16.72H18.7284C18.7164 16.588 18.6604 16.484 18.5604 16.408C18.4644 16.328 18.3344 16.288 18.1704 16.288C18.0184 16.288 17.9004 16.316 17.8164 16.372C17.7364 16.428 17.6964 16.506 17.6964 16.606C17.6964 16.718 17.7524 16.804 17.8644 16.864C17.9764 16.92 18.1504 16.978 18.3864 17.038C18.6264 17.098 18.8244 17.16 18.9804 17.224C19.1364 17.288 19.2704 17.388 19.3824 17.524C19.4984 17.656 19.5584 17.832 19.5624 18.052C19.5624 18.244 19.5084 18.416 19.4004 18.568C19.2964 18.72 19.1444 18.84 18.9444 18.928C18.7484 19.012 18.5184 19.054 18.2544 19.054Z"
                      fill="#6366F1"
                    />
                  </svg>
                </span>
                <span className='m-2'>
                  <svg
                    width="30"
                    height="30"
                    viewBox="0 0 30 30"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <rect
                      x="0.5"
                      y="0.5"
                      width="29"
                      height="29"
                      rx="1.5"
                      fill="white"
                    />
                    <path
                      d="M17.8128 3.75H6.56245C6.31382 3.75001 6.07537 3.84878 5.89956 4.0246C5.72376 4.20041 5.62499 4.43887 5.625 4.6875V25.3125C5.62499 25.5611 5.72376 25.7996 5.89956 25.9754C6.07537 26.1512 6.31382 26.25 6.56245 26.25H23.4375C23.6862 26.25 23.9246 26.1512 24.1004 25.9754C24.2762 25.7996 24.375 25.5611 24.375 25.3125V10.3125M17.8128 3.75L24.375 10.3125M17.8128 3.75L17.8125 10.3125H24.375"
                      stroke="#CEB39B"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <rect
                      x="0.5"
                      y="0.5"
                      width="29"
                      height="29"
                      rx="1.5"
                      stroke="#E8E8E8"
                    />
                    <path
                      d="M11.286 15.628C11.538 15.628 11.762 15.684 11.958 15.796C12.154 15.904 12.306 16.066 12.414 16.282C12.526 16.494 12.582 16.75 12.582 17.05V19H11.742V17.164C11.742 16.9 11.676 16.698 11.544 16.558C11.412 16.414 11.232 16.342 11.004 16.342C10.772 16.342 10.588 16.414 10.452 16.558C10.32 16.698 10.254 16.9 10.254 17.164V19H9.414V14.56H10.254V16.09C10.362 15.946 10.506 15.834 10.686 15.754C10.866 15.67 11.066 15.628 11.286 15.628ZM14.3588 16.366V17.974C14.3588 18.086 14.3848 18.168 14.4368 18.22C14.4928 18.268 14.5848 18.292 14.7128 18.292H15.1028V19H14.5748C13.8668 19 13.5128 18.656 13.5128 17.968V16.366H13.1168V15.676H13.5128V14.854H14.3588V15.676H15.1028V16.366H14.3588ZM19.835 15.628C20.243 15.628 20.571 15.754 20.819 16.006C21.071 16.254 21.197 16.602 21.197 17.05V19H20.357V17.164C20.357 16.904 20.291 16.706 20.159 16.57C20.027 16.43 19.847 16.36 19.619 16.36C19.391 16.36 19.209 16.43 19.073 16.57C18.941 16.706 18.875 16.904 18.875 17.164V19H18.035V17.164C18.035 16.904 17.969 16.706 17.837 16.57C17.705 16.43 17.525 16.36 17.297 16.36C17.065 16.36 16.881 16.43 16.745 16.57C16.613 16.706 16.547 16.904 16.547 17.164V19H15.707V15.676H16.547V16.078C16.655 15.938 16.793 15.828 16.961 15.748C17.133 15.668 17.321 15.628 17.525 15.628C17.785 15.628 18.017 15.684 18.221 15.796C18.425 15.904 18.583 16.06 18.695 16.264C18.803 16.072 18.959 15.918 19.163 15.802C19.371 15.686 19.595 15.628 19.835 15.628ZM22.8341 14.56V19H21.9941V14.56H22.8341Z"
                      fill="#F37708"
                    />
                  </svg>
                </span>
                <span className='m-2'>
                  <svg
                    width="30"
                    height="30"
                    viewBox="0 0 30 30"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <rect
                      x="0.5"
                      y="0.5"
                      width="29"
                      height="29"
                      rx="1.5"
                      fill="white"
                    />
                    <path
                      d="M17.8128 3.75H6.56245C6.31382 3.75001 6.07537 3.84878 5.89956 4.0246C5.72376 4.20041 5.62499 4.43887 5.625 4.6875V25.3125C5.62499 25.5611 5.72376 25.7996 5.89956 25.9754C6.07537 26.1512 6.31382 26.25 6.56245 26.25H23.4375C23.6862 26.25 23.9246 26.1512 24.1004 25.9754C24.2762 25.7996 24.375 25.5611 24.375 25.3125V10.3125M17.8128 3.75L24.375 10.3125M17.8128 3.75L17.8125 10.3125H24.375"
                      stroke="#CEB39B"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <rect
                      x="0.5"
                      y="0.5"
                      width="29"
                      height="29"
                      rx="1.5"
                      stroke="#E8E8E8"
                    />
                    <path
                      d="M11.286 15.628C11.538 15.628 11.762 15.684 11.958 15.796C12.154 15.904 12.306 16.066 12.414 16.282C12.526 16.494 12.582 16.75 12.582 17.05V19H11.742V17.164C11.742 16.9 11.676 16.698 11.544 16.558C11.412 16.414 11.232 16.342 11.004 16.342C10.772 16.342 10.588 16.414 10.452 16.558C10.32 16.698 10.254 16.9 10.254 17.164V19H9.414V14.56H10.254V16.09C10.362 15.946 10.506 15.834 10.686 15.754C10.866 15.67 11.066 15.628 11.286 15.628ZM14.3588 16.366V17.974C14.3588 18.086 14.3848 18.168 14.4368 18.22C14.4928 18.268 14.5848 18.292 14.7128 18.292H15.1028V19H14.5748C13.8668 19 13.5128 18.656 13.5128 17.968V16.366H13.1168V15.676H13.5128V14.854H14.3588V15.676H15.1028V16.366H14.3588ZM19.835 15.628C20.243 15.628 20.571 15.754 20.819 16.006C21.071 16.254 21.197 16.602 21.197 17.05V19H20.357V17.164C20.357 16.904 20.291 16.706 20.159 16.57C20.027 16.43 19.847 16.36 19.619 16.36C19.391 16.36 19.209 16.43 19.073 16.57C18.941 16.706 18.875 16.904 18.875 17.164V19H18.035V17.164C18.035 16.904 17.969 16.706 17.837 16.57C17.705 16.43 17.525 16.36 17.297 16.36C17.065 16.36 16.881 16.43 16.745 16.57C16.613 16.706 16.547 16.904 16.547 17.164V19H15.707V15.676H16.547V16.078C16.655 15.938 16.793 15.828 16.961 15.748C17.133 15.668 17.321 15.628 17.525 15.628C17.785 15.628 18.017 15.684 18.221 15.796C18.425 15.904 18.583 16.06 18.695 16.264C18.803 16.072 18.959 15.918 19.163 15.802C19.371 15.686 19.595 15.628 19.835 15.628ZM22.8341 14.56V19H21.9941V14.56H22.8341Z"
                      fill="#F37708"
                    />
                  </svg>
                </span>
              </div>
            </div>
          </div>

          <div className={'rpsRow2-form'}>

        

              <div className="form-control-reject">
                <input
                  type="text"
                  placeholder="Search by Rejection Reason"
                  className={'no-outline text-muted fs-8 w-90'}
                // value={search}
                // onChange={handleSearchChange}
                />

                <img src={searchCollection} alt="search" className="icon-style" />
              </div>

          </div>

          <div className={'psRow3'} style={{ overflowX: "auto" }}>
            <Table
              rowSelection={rowSelection}
                 bordered
              dataSource={[...dataSourceD]}
              columns={columns}
                 scroll={{ x: "1800px" }}
            />
          </div>
        </div>

        <Modal
          centered
          style={{ width: '500px', maxWidth: '100%' }}
          open={confirmationModal}
          onOk={() => setConfirmationModal(false)}
          onCancel={() => setConfirmationModal(false)}
          footer={null}
        >
          <div className={'rvpConfirmationModal'}>
            <svg
              style={{ justifySelf: 'center' }}
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M11.2499 13.8755C11.2499 14.2897 11.5857 14.6255 11.9999 14.6255C12.4142 14.6255 12.7499 14.2897 12.7499 13.8755H11.2499ZM11.9999 12.938V12.188C11.801 12.188 11.6103 12.267 11.4696 12.4077C11.329 12.5483 11.2499 12.7391 11.2499 12.938H11.9999ZM7.96869 9.65678C7.96869 10.071 8.30448 10.4068 8.71869 10.4068C9.1329 10.4068 9.46869 10.071 9.46869 9.65678H7.96869ZM22.5 12C22.5 17.799 17.799 22.5 12 22.5V24C18.6274 24 24 18.6274 24 12H22.5ZM12 22.5C6.20101 22.5 1.5 17.799 1.5 12H0C0 18.6274 5.37258 24 12 24V22.5ZM1.5 12C1.5 6.20101 6.20101 1.5 12 1.5V0C5.37258 0 0 5.37258 0 12H1.5ZM12 1.5C17.799 1.5 22.5 6.20101 22.5 12H24C24 5.37258 18.6274 0 12 0V1.5ZM12.6562 18.0938C12.6562 18.4562 12.3624 18.75 12 18.75V20.25C13.1909 20.25 14.1562 19.2846 14.1562 18.0938H12.6562ZM12 18.75C11.6376 18.75 11.3438 18.4562 11.3438 18.0938H9.84375C9.84375 19.2846 10.8091 20.25 12 20.25V18.75ZM11.3438 18.0938C11.3438 17.7313 11.6376 17.4375 12 17.4375V15.9375C10.8091 15.9375 9.84375 16.9029 9.84375 18.0938H11.3438ZM12 17.4375C12.3624 17.4375 12.6562 17.7313 12.6562 18.0938H14.1562C14.1562 16.9029 13.1909 15.9375 12 15.9375V17.4375ZM12.7499 13.8755V12.938H11.2499V13.8755H12.7499ZM11.9999 13.688C12.7972 13.688 13.5766 13.4516 14.2396 13.0086L13.4062 11.7614C12.99 12.0396 12.5006 12.188 11.9999 12.188L11.9999 13.688ZM14.2396 13.0086C14.9025 12.5657 15.4192 11.9361 15.7243 11.1995L14.3385 10.6254C14.1469 11.088 13.8225 11.4833 13.4062 11.7614L14.2396 13.0086ZM15.7243 11.1995C16.0294 10.4629 16.1093 9.6523 15.9537 8.87032L14.4826 9.16295C14.5802 9.65397 14.5301 10.1629 14.3385 10.6254L15.7243 11.1995ZM15.9537 8.87032C15.7982 8.08833 15.4142 7.37003 14.8505 6.80625L13.7898 7.86691C14.1438 8.22091 14.3849 8.67194 14.4826 9.16295L15.9537 8.87032ZM14.8505 6.80625C14.2867 6.24247 13.5684 5.85853 12.7864 5.70299L12.4938 7.17416C12.9848 7.27183 13.4358 7.51291 13.7898 7.86691L14.8505 6.80625ZM12.7864 5.70299C12.0044 5.54744 11.1939 5.62727 10.4572 5.93239L11.0313 7.31821C11.4938 7.12662 12.0027 7.0765 12.4938 7.17416L12.7864 5.70299ZM10.4572 5.93239C9.72063 6.2375 9.09104 6.7542 8.64808 7.41713L9.89528 8.25049C10.1734 7.83423 10.5687 7.50979 11.0313 7.31821L10.4572 5.93239ZM8.64808 7.41713C8.20512 8.08007 7.96869 8.85947 7.96869 9.65678H9.46869C9.46869 9.15614 9.61715 8.66675 9.89528 8.25049L8.64808 7.41713Z"
                fill="#61CD85"
              />
            </svg>

            {/*<div className={'rdFilterModalRow1'}>*/}
            <div className={'rvpConfirmationModalTitle'}>Confirmation</div>
            {/*</div>*/}

            <div style={{ justifySelf: 'center' }}>
              Please confirm you want to proceed with this request
            </div>

            <div className={'rvpConfirmationModalActionButton'}>
              <button
                className="btn btn-outline-success px-7 py-2 h-44 w-200 rounded-1 "
                onClick={() => setConfirmationModal(false)}
              >
                <span className="indicator-label fs-base">Cancel</span>
              </button>

              <button
                onClick={() => {
                  setSuccessModal(true);
                }}
                className="btn btn-success px-7 py-2 h-44 w-150 rounded-1 "
              >
                <span className="indicator-label fs-base text-White">
                  Proceed
                </span>
              </button>
            </div>
          </div>
        </Modal>

        <Modal
          centered
          style={{ width: '500px', maxWidth: '100%' }}
          open={successModal}
          onOk={() => setSuccessModal(false)}
          onCancel={() => setSuccessModal(false)}
          footer={null}
        >
          <div className={'rvpConfirmationModal'}>
            <svg
              style={{ justifySelf: 'center' }}
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M17.1562 9.1875L10.2812 15.75L6.84375 12.4688M23.25 12C23.25 18.2132 18.2132 23.25 12 23.25C5.7868 23.25 0.75 18.2132 0.75 12C0.75 5.7868 5.7868 0.75 12 0.75C18.2132 0.75 23.25 5.7868 23.25 12Z"
                stroke="#61CD85"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>

            <div className={'rvpConfirmationModalTitle'}>Successful!</div>

            <div style={{ textAlign: 'center' }}>
              Your payment request with batch no{' '}
              <span style={{ color: '#6366F1' }}>1234567890</span> has been
              successfully sent to the initiator group for funding and onward
              transmission to the approval group for action
            </div>

            <div className={'rvpConfirmationModalActionButton'}>
              <button
                className="btn btn-success px-7 py-2 h-44 w-150 rounded-1 "
                onClick={() => {
                  setSuccessModal(false);
                  setDataSource([]);
                  navigate('/admin/payment/reprocess-unpaid-payments');
                }}
              >
                <span className="indicator-label fs-base text-White">Ok</span>
              </button>
            </div>
          </div>
        </Modal>
      </div>
    </>
  );
};

export default FailedPayments;
